<template>
  <div id="the-app" :class="routeClass">
    <UseGetPicaForYourEvent/>
    <TheHeader v-if="isAuthenticated"/>
    <ModalCheckinMaker v-if="isAuthenticated"/>
    <ModalPreCheckinDataCollector v-if="isAuthenticated"/>
    <ModalPreCheckinFaceRecognition v-if="isAuthenticated"/>
    <ModalCheckinOptions v-if="isAuthenticated"/>
    <ModalMarketingConsent v-if="isAuthenticated"/>
    <div class="noty-custom-container"></div>
    <div class="router-container">
      <router-view :key="$route.fullPath" ref="refView"/>
    </div>
    <ModalMinimumAge v-if="minRequiredAge"/>
    <RealtimeNotificationManager />
    <RealtimeNotificationPopup />
    <TheFooter/>
  </div>
</template>


<script>
import {getBrowserLanguage, i18n} from './i18n'

import {mapGetters, mapActions} from 'vuex'
import TheHeader from "@/components/TheHeader"
import TheFooter from "@/components/TheFooter"
import ModalCheckinMaker from "@/components/ModalCheckinMaker"
import ModalPreCheckinDataCollector from "@/domain/checkin/ModalPreCheckinDataCollector"
import ModalPreCheckinFaceRecognition from "@/domain/checkin/ModalPreCheckinFaceRecognition"
import ModalMarketingConsent from "@/components/ModalMarketingConsent"
import ModalCheckinOptions from "@/domain/checkin/ModalCheckinOptions.vue";
import UseGetPicaForYourEvent from "@/domain/bannerGetPica/UseGetPicaForYourEvent.vue";
import ModalMinimumAge from "@/components/ModalMinimumAge.vue";
import RealtimeNotificationPopup from "@/domain/realtimeNotifications/RealtimeNotificationPopup.vue";
import RealtimeNotificationManager from "@/domain/realtimeNotifications/RealtimeNotificationManager.vue";
import eventBusConstants from "@/domain/core/constants/eventBus";

export default {
  name: 'App',
  
  
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: i18n.t('seo.title'),
    // all titles will be injected into this template
    titleTemplate: '%s',
    htmlAttrs: {
      lang: getBrowserLanguage(),
      amp: true
    },
    meta: [
      // vmid will be used to substitute the existing tag
      {vmid: 'description', name: 'description', content: i18n.t('seo.meta_description')}
    ]
  },

  components: {
    ModalMinimumAge,
    UseGetPicaForYourEvent,
    TheHeader,
    TheFooter,
    ModalCheckinMaker,
    ModalPreCheckinDataCollector,
    ModalPreCheckinFaceRecognition,
    ModalMarketingConsent,
    ModalCheckinOptions,
    RealtimeNotificationPopup,
    RealtimeNotificationManager
  },

  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('appConfig', [
      'hideCart', 'minRequiredAge', "getAppConfigReady"
    ]),
    routeClass() {
      if (!this.$route) return ''
      return this.$route.name
    }
  },

  watch: {
    isAuthenticated() {
    }
  },

  mounted() {
    
    // Register for notification events
    this.registerEvent(eventBusConstants.realtimeNotifications.reload_requested, this.handleReloadEvent)

    // Disable right click
    if (process.env.NODE_ENV !== "development") {
      document.body.addEventListener('contextmenu', evt => {
        evt.stopPropagation()
        evt.preventDefault()
      })
    }
  },

  beforeDestroy() {
    // Unregister event listeners
    this.unregisterEvent(eventBusConstants.realtimeNotifications.reload_requested, this.handleReloadEvent)
  },

  methods: {
    
    
    handleReload() {
      // Emit reload event via event bus
      this.emitEvent(eventBusConstants.realtimeNotifications.reload_requested, {
        galleryId: null
      })
    },
    
    handleReloadEvent(payload) {
      console.log('App received reload event:', payload)
      // Reload the current page
      this.$router.go(0)
    },
    
  }
}
</script>
